<template>
  <div>
    <h3>タグ管理</h3>
    <InputText v-model="tag" class="" type="text" placeholder="追加したいタグ" />
    <Button @click="send" label="追加" />
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import firebase from "../firebase/firebase";

export default defineComponent({
  name: "AddTag",
  components: {
    InputText,
    Button,
  },
  setup() {
    return {
      tag: ref(""),
    };
  },
  methods: {
    send: async function () {
      await firebase
        .firestore()
        .collection("misc")
        .doc("tags")
        .update({
          tags: firebase.firestore.FieldValue.arrayUnion(this.tag),
        })
        .then(() => {
          console.log(this.tag);
        })
        .catch((err) => {
          console.log(err);
        });
      this.tag = "";
      this.$emit('updateTags')
    },
  },
});
</script>

<style scoped>
</style>
